import { render, staticRenderFns } from "./ChannelsPanel.vue?vue&type=template&id=7809dba7&scoped=true"
import script from "./ChannelsPanel.vue?vue&type=script&lang=js"
export * from "./ChannelsPanel.vue?vue&type=script&lang=js"
import style0 from "./ChannelsPanel.vue?vue&type=style&index=0&id=7809dba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809dba7",
  null
  
)

export default component.exports